"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableViewPresetDomainSchema = exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORIES_ORDERED = exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORY_META = exports.SystemTableViewPresetCategory = exports.TableViewPresetTableName = void 0;
const filters_1 = require("../interfaces/filters");
const orderBy_1 = require("../interfaces/orderBy");
const zod_1 = __importDefault(require("zod"));
var TableViewPresetTableName;
(function (TableViewPresetTableName) {
    TableViewPresetTableName["Traces"] = "traces";
    TableViewPresetTableName["Observations"] = "observations";
    TableViewPresetTableName["ObservationsEvents"] = "observations-events";
    TableViewPresetTableName["Scores"] = "scores";
    TableViewPresetTableName["Sessions"] = "sessions";
    TableViewPresetTableName["SessionDetail"] = "session-detail";
    TableViewPresetTableName["Datasets"] = "datasets";
    TableViewPresetTableName["Experiments"] = "experiments";
    TableViewPresetTableName["ExperimentItems"] = "experiment-items";
    TableViewPresetTableName["Evaluators"] = "evaluators-v2";
    TableViewPresetTableName["EvaluationRules"] = "evaluation-rules-v2";
    TableViewPresetTableName["Users"] = "users";
    TableViewPresetTableName["Prompts"] = "prompts";
    TableViewPresetTableName["Monitors"] = "monitors";
})(TableViewPresetTableName || (exports.TableViewPresetTableName = TableViewPresetTableName = {}));
/**
 * Categories used to group system table view presets into the quick-access
 * chip row rendered beneath the search bar (v4 events table). This enum is the
 * single source of truth for grouping and display order; the frontend maps
 * each category to an icon locally (lucide icons are not available in shared).
 */
var SystemTableViewPresetCategory;
(function (SystemTableViewPresetCategory) {
    SystemTableViewPresetCategory["SlowCalls"] = "slow-calls";
    SystemTableViewPresetCategory["Errors"] = "errors";
    SystemTableViewPresetCategory["CostRegression"] = "cost-regression";
})(SystemTableViewPresetCategory || (exports.SystemTableViewPresetCategory = SystemTableViewPresetCategory = {}));
exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORY_META = {
    // The Errors category is surfaced to users as "Quality" — it groups error,
    // output-review, and (coming-soon) eval-score / feedback presets.
    [SystemTableViewPresetCategory.Errors]: {
        label: "Quality",
        order: 1,
    },
    [SystemTableViewPresetCategory.SlowCalls]: { label: "Slow", order: 2 },
    [SystemTableViewPresetCategory.CostRegression]: {
        label: "Cost",
        order: 3,
    },
};
/** Categories in their defined display order. */
exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORIES_ORDERED = Object.keys(exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORY_META).sort((a, b) => exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORY_META[a].order -
    exports.SYSTEM_TABLE_VIEW_PRESET_CATEGORY_META[b].order);
exports.TableViewPresetDomainSchema = zod_1.default.object({
    id: zod_1.default.string(),
    projectId: zod_1.default.string().nullable(),
    createdAt: zod_1.default.date(),
    updatedAt: zod_1.default.date(),
    createdBy: zod_1.default.string().nullable(),
    name: zod_1.default.string(),
    tableName: zod_1.default.enum(TableViewPresetTableName),
    filters: zod_1.default.array(filters_1.singleFilter),
    columnOrder: zod_1.default.array(zod_1.default.string()),
    columnVisibility: zod_1.default.record(zod_1.default.string(), zod_1.default.boolean()),
    searchQuery: zod_1.default.string().nullable(),
    orderBy: orderBy_1.orderBy,
});
